import { webComponentBaseClass } from "/third_party/web-component-base-class/dist/webComponentBaseClass.js";
import "../davinci-navigate-control/davinci-navigate-control.js";

function handleRouterChange(part) {
	Array.from(part.$.controlContainer.querySelectorAll("davinci-navigate-control")).forEach((control) => {
		control.router = part[privateData].router;
	});
}

const privateData = Symbol("privateData");

async function handleNavFileChange(part) {
	try {
		const controlData = part[privateData];
		const result = await fetch(part.navigationFile);
		const data = await result.json();
		const handleActivated = (navControl) => {
			Array.from(part.$.controlContainer.querySelectorAll("davinci-navigate-control")).filter((control) => control !== navControl && control.active).forEach((control) => control.active = false)
		};

		if (data.navigation && data.navigation.tree) {
			part.$.controlContainer.innerHTML = "";
			data.navigation.tree.forEach((navItem) => {
				const navControl = document.createElement("davinci-navigate-control");
				part.$.controlContainer.appendChild(navControl);
				navControl.navigateData = navItem;
				navControl.onActivate = handleActivated;
				if (controlData.targetContentContainer && controlData.targetContentContainer.location === navControl.url) {
					navControl.active = true;
				}
			});
			handleRouterChange(part);
		}
	} catch(err) {
		console.error(err);
	}
}

const customElementName = "davinci-navigate";
window.customElements.define(customElementName, class extends webComponentBaseClass {
	static get is() { return customElementName; }

	constructor() {
		super();
		this[privateData] = {
			router: null,
		};
		this.onRoute = this.onRoute.bind(this);
	}

	// add properties to this web component
	static get properties() {
		return {
			 navigationFile: { // the name of the property
				 type: String, // (required) the type of the property, one of Array, Boolean, Number, Object, String
				 reflectToAttribute: true, // (optional) indicate if you want the component attribute to always reflect the current property value
				 observer: handleNavFileChange, // (optional) the name or a symbol for a function in the class to be called when the value of the property is changed
			 },
		};
	}

	// optional callback function that will be called after this instance of the web component
	// has been added to the DOM
	attached() {
		// extra initialization that only can be done after an instance of the class has been attached to the DOM
	}

	// optional callback function that will be called after this instance of the web component has been removed from the DOM
	detached() {
		// extra cleanup that only can be done after an instance of the class has been removed from the DOM
	}

	set router(router) {
		this[privateData].router = router;
		handleRouterChange(this);
	}

	onRoute(context, next) {
		if (context.params.file) {
			Array.from(this.$.controlContainer.querySelectorAll('davinci-navigate-control')).forEach((navControl) => {
				const regExpTest = new RegExp(`(^|/)${context.params.file}.js$`);
				navControl.active = regExpTest.test(navControl.navigateData.url);
			});
		}
		next();
	}

	// string representation of the template to use with this web component
	static get template() {
		return `
            <style>
            	#control-container {
            		display: flex;
            		flex-direction: column;
            		align-items: stretch;
            		justify-content: stretch;
            		padding: 1em 2.2em 1em 1.5em;
            	}
            	
            	davinci-navigate-control {
            		flex: 1 1 auto;
            	}
            </style>
            <div id="control-container">
            
			</div>
        `;
	}
});
